<template>
  <div>
    <CrudList
      title="Notificaciones"
      storeName="Send_notifications"
      :canAdd="user.user_role != 'admin_enterprise'"
      :canEdit="false"
      :canDelete="true"
      :role_admin_enterprise="user.user_role == 'admin_enterprise'"
      sortable
    >
    <template v-slot:date="{ item }">
      {{ formatDate(item.date) }}
    </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import { mapState } from 'vuex';
  import CrudFormMixin from "@/mixins/crud_form";
  export default {
    mixins: [CrudFormMixin],
    components: {CrudList},
    computed: {
      ...mapState({
        user: state => state.Authenticate.user,
      }),
    },
    data(){
      return{
        role_enterprise: false, 
      }
    },
    async created() {
      const self = this;
      await self.$store.dispatch("Authenticate/me");
    },
  };
</script>
